import type { IAPI } from '../../apiResponse';
import { getRequest, type IRequestOptions } from '../../httpClient';
import {
  getPublicCollectionBySlugV4ResponseSchema,
  type ICollectionV4,
} from './get-public-collection-by-slug-v4-response';

export async function getPublicCollectionBySlugV4Api(slug: string, options?: IRequestOptions) {
  return getRequest<IAPI<ICollectionV4>>({
    path: `/collections/v4/slug/${encodeURIComponent(slug)}`,
    options,
    schema: getPublicCollectionBySlugV4ResponseSchema,
  });
}
